import { useQuery } from "@apollo/client"
import { GET_ORGANIZATION_GROUPS_BY_ID } from "../graphql/queries/getOrganizationGroupsById"

export const useOrganizationGroupsById = (id: number) => {
  const { data, error, loading, refetch } = useQuery(GET_ORGANIZATION_GROUPS_BY_ID, { variables: { id: id } })
  return { organization: data?.organization, error, loading, refetch }
}
